const translations = {
    noBatteriesFound: 'No batteries found',
    search: 'Search batteries'
};

export default translations;
